/**
 * @description 构建类型
 */

//微信
export const build_wechat = 'wechat';

//h5
export const build_h5 = 'h5';